/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import McQueryResult from './McQueryResult';

/**
 * The McOutputCmsMcs model module.
 * @module model/McOutputCmsMcs
 * @version 1.0
 */
class McOutputCmsMcs {
    /**
     * Constructs a new <code>McOutputCmsMcs</code>.
     * @alias module:model/McOutputCmsMcs
     */
    constructor() { 
        
        McOutputCmsMcs.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>McOutputCmsMcs</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/McOutputCmsMcs} obj Optional instance to populate.
     * @return {module:model/McOutputCmsMcs} The populated <code>McOutputCmsMcs</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new McOutputCmsMcs();

            if (data.hasOwnProperty('mcs')) {
                obj['mcs'] = ApiClient.convertToType(data['mcs'], [McQueryResult]);
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/McQueryResult>} mcs
 */
McOutputCmsMcs.prototype['mcs'] = undefined;






export default McOutputCmsMcs;

